import "styles/index.css";

import React from "react";

import { Text, TextTitle, TextDescription } from "components/Texts";
import Button from "components/Buttons";
import Alert from "components/Alert";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const AdsConfirmation = ({
  selectedGoogleAds,
  selectedFacebookAds,
  onConfirm,
  onCancel,
  isSetting,
  errorText,
  businessName,
}) => {
  const [t] = useTranslation();
  return (
    <StyledContainer>
      <TextTitle className="title">{t(isSetting ? "__ads_account" : "__setup_ads")}</TextTitle>
      {errorText && <Alert>{errorText}</Alert>}
      {businessName ? (
        <>
          <TextDescription>{t("__business_name")}</TextDescription>
          <Text className="value">{businessName}</Text>
        </>
      ) : null}
      {selectedGoogleAds ? (
        <>
          <TextDescription>{t("__google_ads")}</TextDescription>
          <Text className="value">{selectedGoogleAds.title}</Text>
        </>
      ) : null}
      {selectedFacebookAds ? (
        <>
          <TextDescription>{t("__facebook_ads")}</TextDescription>
          <Text className="value">{selectedFacebookAds.title}</Text>
        </>
      ) : null}
      <Button onClick={onConfirm} full>
        {t("__confirm")}
      </Button>
      <Button onClick={onCancel} type="link" full className="cancel-btn">
        {t("__cancel")}
      </Button>
    </StyledContainer>
  );
};

export default AdsConfirmation;

const StyledContainer = styled.div`
  .title {
    text-align: center;
    margin-bottom: 16px;
  }

  .label {
    margin: 16px 0 8px;
  }

  .value {
    margin: 0 0 16px;
  }

  .dropdown-button {
    margin-bottom: 24px;
  }
`;
